import Container from '@mui/material/Container';
import { paths } from 'src/routes/paths';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import EmentasForm from '../ementas-form';

export default function EmentaCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Criar nova ementa"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Ementas',
            href: paths.dashboard.ementas.list,
          },
          { name: 'Criar' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <EmentasForm />
    </Container>
  );
}
